var Base = require('front/components/Base/Base');
var _ = require('underscore');

var ArticlesList = require('front/components/ArticlesList/ArticlesList');
require('front/components/Header/Header');
require('front/components/SectionSide/SectionSide');

require('./Author.less');

module.exports = Base.extend({
    el: '.Author',

    initialize: function () {
        this.articlesList = new ArticlesList({
            apiUrl: window.app.settings.urls.api.articles,
            limit: 10,
            dataOptions: {
                author: app.data.author.id
            }
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Author/Author.js
// module id = 182
// module chunks = 0